export default {
    baseUrl: 'https://acc2.calmos.myapps.biorius.com/api',
    notificatorUrl: 'https://localhost:8000',
};
